import { StrapiResponse } from '../types/core';
import { TOSVersionResponse } from '../types/tosVersion';
import api from './api';

export default {
  async getLatest(): Promise<StrapiResponse<TOSVersionResponse, any>> {
    return (await api.get('/tos-version/latest'))?.data;
  },
};
